<template>
	<div class="layout-container">
		<aside class="sidebar">
			<div class="sidebar-header">
				<h1 class="logo">柏宁AI智能体</h1>
			</div>
			<el-menu :default-active="activeMenu" class="sidebar-menu" mode="vertical" @select="handleMenuSelect">
				<el-submenu index="user-permission" v-if="adminInfo.adminLevel === 0||adminInfo.adminLevel === 1">
					<template slot="title">
						<i class="el-icon-user"></i>
						<span>用户权限</span>
					</template>
					<el-menu-item index="admin">用户管理</el-menu-item>
				</el-submenu>
				<el-submenu index="aigc">
					<template slot="title">
						<i class="el-icon-picture"></i>
						<span>AIGC</span>
					</template>
					<el-menu-item index="assignment">画布工厂</el-menu-item>
					<el-menu-item index="digital-human" style="display: none;">数字人</el-menu-item>
					<el-menu-item index="material-assets">素材资产</el-menu-item>
				</el-submenu>
				<el-submenu index="media">
					<template slot="title">
						<i class="el-icon-video-camera"></i>
						<span>媒体服务</span>
					</template>
					<el-menu-item index="face-swap">人物换脸</el-menu-item>
					<el-menu-item index="dubbing">台词替换</el-menu-item>
					<el-menu-item index="subtitle">实时字幕</el-menu-item>
				</el-submenu>
				<el-submenu index="online-tools">
					<template slot="title">
						<i class="el-icon-s-tools"></i>
						<span>在线工具</span>
					</template>
					<el-menu-item index="video-edit" style="display: none;">视频精剪</el-menu-item>
					<el-menu-item index="video-mix" style="display: none;">视频混剪</el-menu-item>
					<el-menu-item index="remove-watermark">擦除字幕水印</el-menu-item>
				</el-submenu>
			</el-menu>
			<div class="sidebar-footer">
				<div class="user-info" @click="toggleMenu">
					<el-avatar :size="40">{{ adminInfo.adminName ? adminInfo.adminName.slice(-1) : 'U' }}</el-avatar>
					<div class="user-details">
						<p class="user-name">{{ adminInfo.adminName }}</p>
						<p class="user-level">{{ getLevelLabel(adminInfo.adminLevel) }}</p>
					</div>
				</div>
				<div class="user-menu" v-show="menuExpanded">
					<div class="menu-item active" @click.stop="handleProfile">
						<i class="el-icon-user"></i>
						<span>个人中心</span>
					</div>
					<div class="menu-item" @click.stop="handleLogout">
						<i class="el-icon-switch-button"></i>
						<span>退出登录</span>
					</div>
				</div>
			</div>
		</aside>
		<main class="main-content">
			<header class="content-header">
				<h3>{{ currentTitle }}</h3>
			</header>
			<div class="content-body">
				<transition name="fade-slide" mode="out-in">
					<router-view />
				</transition>
			</div>
		</main>

		<el-dialog title="个人中心" :visible.sync="profileDialogVisible" width="900px" @open="onProfileDialogOpen">
			<el-tabs v-model="profileActiveTab">
				<el-tab-pane label="基础资料" name="basic">
					<el-form :model="profileForm" label-width="100px" class="profile-form" ref="profileFormRef">
						<el-form-item label="用户名">
							<el-input v-model="profileForm.adminName" placeholder="请输入用户名"></el-input>
						</el-form-item>
						<el-form-item label="手机号">
							<el-input v-model="profileForm.adminPhone" placeholder="请输入手机号" maxlength="11" minlength="11"></el-input>
						</el-form-item>
						<el-form-item label="密码">
							<el-input v-model="profileForm.adminPwd" placeholder="请输入密码" show-password></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="handleUpdateProfile"
								:loading="profileSubmitting">保存修改</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="数据概览" name="data" >
					<div class="profile-filter" style="display: none;">
						<el-select v-model="profileForm.adminDataType" placeholder="选择数据类型" class="data-type-select"
							@change="handleProfileFilterChange">
							<el-option label="全部" value=""></el-option>
							<el-option label="文本" :value="1"></el-option>
							<el-option label="图片" :value="2"></el-option>
							<el-option label="音频" :value="3"></el-option>
							<el-option label="视频" :value="4"></el-option>
						</el-select>
						<el-select v-model="profileForm.adminId" placeholder="选择用户" class="data-type-select"
							@change="handleProfileFilterChange" v-if="adminInfo.adminLevel == 0" style="margin-left: 10px; ">
							<el-option v-for="item in adminList" :key="item.adminId" :label="item.adminName" :value="item.adminId"></el-option>
						</el-select>
					</div>
					<el-table :data="adminDataList" border stripe class="profile-table" v-loading="profileLoading" style="display: none;">
						<el-table-column prop="adminDataType" label="类型" min-width="100">
							<template slot-scope="scope">
								<el-tag :type="getDataTypeTagType(scope.row.adminDataType)" size="small">
									{{ getDataTypeLabel(scope.row.adminDataType) }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="adminDataNum" label="生成数量/条" min-width="120"></el-table-column>
						<el-table-column prop="adminDataToken" label="消耗Token" min-width="150"></el-table-column>
						<el-table-column prop="adminDataMoney" label="花费" min-width="150"></el-table-column>
						<el-table-column prop="adminDataAddTime" label="创建时间" min-width="160"></el-table-column>
					</el-table>
					<div class="profile-pagination" style="display: none;">
						<el-pagination @size-change="handleProfileSizeChange"
							@current-change="handleProfileCurrentChange" :current-page="profilePageNum"
							:page-sizes="[10, 20, 50]" :page-size="profilePageCount" :total="profileTotal"
							layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	const BASE_URL = 'https://ai.boningnet.cn/api'
	export default {
		name: 'Layout',
		data() {
			return {
				activeMenu: 'assignment',
				titleMap: {
					'assignment': '画布工厂',//文本 视频 图片 花费Token均不一致
					'digital-human': '数字人', //1元/秒视频生成+约0.17元/秒音频合成 最长1分钟
					'face-swap': '人物换脸', //0.8元/分钟 最长10分钟
					'material-assets': '素材资产',//在线加载、播放和下载均为0.8元/GB
					'dubbing': '台词替换', //0.3元/秒口型+约0.17元/秒音频合成 最长2分钟
					'subtitle': '实时字幕', //0.04元/分钟
					'video-edit': '视频精剪',
					'video-mix': '视频混剪',
					'remove-watermark': '擦除字幕水印', //1元/分钟
					'admin': '用户管理'
				},
				adminInfo: {},
				menuExpanded: false,
				profileDialogVisible: false,
				profileLoading: false,
				profileSubmitting: false,
				profileActiveTab: 'basic',
				adminDataList: [],
				profilePageNum: 1,
				profilePageCount: 10,
				profileTotal: 0,
				profileForm: {
					adminName: '',
					adminPhone: '',
					adminPwd: '',
					adminDataType: '',
					adminId: ''
				},
				adminList: []
			}
		},
		computed: {
			currentTitle() {
				this.adminInfo = JSON.parse(localStorage.getItem('adminInfo'))
				axios.get(`${BASE_URL}/admin/get`, {
					params: {
						token: this.adminInfo.adminToken,
						adminToken: this.adminInfo.adminToken
					}
				}).then(res => {
					if (res.data.adminStatus == 0) {
						this.$message.error('用户已被禁用，请联系管理员启用')
						localStorage.clear()
						this.$router.push('/login')
						return ''
					}
					if (res.data.adminLevel !== this.adminInfo.adminLevel) {
						this.$message.info('用户权限变更，请重新登录获取最新权限信息')
						localStorage.clear()
						this.$router.push('/login')
						return ''
					}
					if (res.data.adminPwd !== this.adminInfo.adminPwd || res.data.adminName !== this.adminInfo
						.adminName || res.data.adminId === 0) {
						this.$message.info('信息核验有误，请重新登录')
						localStorage.clear()
						this.$router.push('/login')
						return ''
					}
				}).catch(() => {
					this.$message.error('信息核验失败，请重新登录')
					localStorage.clear()
					this.$router.push('/login')
					return ''
				}).finally(() => {
					this.loading = false
				})
				return this.titleMap[this.activeMenu] || ''
			}
		},
		watch: {
			'$route'(to) {
				const path = to.path.slice(1)
				if (this.titleMap[path]) {
					this.activeMenu = path
				}
			}
		},
		methods: {
			handleMenuSelect(index) {
				this.activeMenu = index
				this.$router.push(`/${index}`)
			},
			getLevelLabel(level) {
				switch (level) {
					case 0:
						return '超级管理员'
					case 1:
						return '管理员'
					case 2:
						return '运营'
					default:
						return '未知'
				}
			},
			toggleMenu() {
				this.menuExpanded = !this.menuExpanded
			},
			handleProfile() {
				this.menuExpanded = false
				this.profileDialogVisible = true
			},
			onProfileDialogOpen() {
				this.profileActiveTab = 'basic'
				this.profilePageNum = 1
				this.profilePageCount = 10
				this.profileForm.adminDataType = ''
				this.profileForm.adminId = this.adminInfo.adminId
				this.loadProfileForm()
				this.fetchAdminData()
			},
			loadProfileForm() {
				this.profileForm.adminName = this.adminInfo.adminName || ''
				this.profileForm.adminPhone = this.adminInfo.adminPhone || ''
				this.profileForm.adminPwd = this.adminInfo.adminPwd || ''
			},
			async handleUpdateProfile() {
				if (!this.profileForm.adminName) {
					this.$message.warning('请输入昵称')
					return
				}
				if (!this.profileForm.adminPhone) {
					this.$message.warning('请输入手机号')
					return
				}
				this.profileSubmitting = true
				try {
					const data = {
						adminId: this.adminInfo.adminId,
						adminName: this.profileForm.adminName,
						adminPhone: this.profileForm.adminPhone,
						adminPwd: this.profileForm.adminPwd,
						adminLevel: this.adminInfo.adminLevel,
						adminStatus: this.adminInfo.adminStatus,
						adminToken: this.adminInfo.adminToken
					}
					await axios.post(`${BASE_URL}/admin/update?token=${this.adminInfo.adminToken}`, data)
					this.$message.success('资料更新成功')
					this.adminInfo.adminName = this.profileForm.adminName
					this.adminInfo.adminPhone = this.profileForm.adminPhone
					this.adminInfo.adminPwd = this.profileForm.adminPwd
					localStorage.setItem('adminInfo', JSON.stringify(this.adminInfo))
				} catch (error) {
					this.$message.error('资料更新失败')
				} finally {
					this.profileSubmitting = false
				}
			},
			handleProfileFilterChange() {
				this.profilePageNum = 1
				this.fetchAdminData()
			},
			handleProfileSizeChange(val) {
				this.profilePageCount = val
				this.profilePageNum = 1
				this.fetchAdminData()
			},
			handleProfileCurrentChange(val) {
				this.profilePageNum = val
				this.fetchAdminData()
			},
			async fetchAdminData() {
				this.profileLoading = true
				try {
					if (this.adminInfo.adminLevel === 0) {
						const params2={
								token: this.adminInfo.adminToken,
								pageNum: 1,
								pageCount: 99999
							}
						const res2 = await axios.get(`${BASE_URL}/admin/list`, {
								params: params2
						})
						this.adminList = res2.data || []
					}

					const params = {
						token: this.adminInfo.adminToken,
						pageNum: this.profilePageNum,
						pageCount: this.profilePageCount,
						adminId: this.profileForm.adminId
					}
					if (this.profileForm.adminDataType !== '' && this.profileForm.adminDataType !== null) {
						params.adminDataType = this.profileForm.adminDataType
					}
					const res = await axios.get(`${BASE_URL}/admin_data/list`, {
						params
					})
					this.adminDataList = res.data || []
					if (this.adminDataList.length > 0 && this.adminDataList[0].allcount !== undefined) {
						this.profileTotal = this.adminDataList[0].allcount || 0
					} else {
						this.profileTotal = this.adminDataList.length
					}
				} catch (error) {
					this.$message.error('加载数据失败')
				} finally {
					this.profileLoading = false
				}
			},
			getDataTypeLabel(type) {
				const map = {
					1: '文本',
					2: '图片',
					3: '音频',
					4: '视频'
				}
				return map[type] || '未知'
			},
			getDataTypeTagType(type) {
				const map = {
					1: '',
					2: 'success',
					3: 'warning',
					4: 'info',
					5: 'danger',
					6: ''
				}
				return map[type] || ''
			},
			handleLogout() {
				this.$confirm('确定要退出登录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					localStorage.removeItem('adminInfo')
					this.$router.push('/login')
				})
			}
		},
		mounted() {
			this.adminInfo = JSON.parse(localStorage.getItem('adminInfo'))
			const path = this.$route.path.slice(1)
			if (path === 'user-management' && this.adminInfo.adminLevel > 0) {
				this.$router.push('/assignment')
			} else if (this.titleMap[path]) {
				this.activeMenu = path
			}
		}
	}
</script>

<style scoped>
	.layout-container {
		display: flex;
		height: 100%;
		background-color: #f5f7fa;
	}

	.sidebar {
		width: 220px;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		border-right: 1px solid #e5e7eb;
		position: relative;
	}

	.sidebar-header {
		padding: 24px 20px;
		border-bottom: 1px solid #e5e7eb;
	}

	.logo {
		color: #1f2937;
		font-size: 18px;
		font-weight: 600;
		margin: 0;
		letter-spacing: 1px;
	}

	.sidebar-menu {
		flex: 1;
		border-right: none;
		padding-top: 12px;
		overflow-y: auto;
	}

	.sidebar-footer {
		padding: 16px;
		border-top: 1px solid #e5e7eb;
	}

	.user-info {
		display: flex;
		align-items: center;
		gap: 10px;
		cursor: pointer;
		padding: 10px 12px;
		border-radius: 8px;
		transition: background-color 0.2s;
	}

	.user-info:hover {
		background-color: rgba(79, 70, 229, 0.08);
	}

	.user-details {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.user-name {
		font-size: 14px;
		font-weight: 600;
		color: #1f2937;
		margin: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.user-level {
		font-size: 12px;
		color: #6b7280;
		margin: 2px 0 0 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.user-menu {
		position: absolute;
		bottom: 80px;
		left: 12px;
		right: 12px;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
		padding: 4px 0;
		z-index: 100;
	}

	.menu-item {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 16px;
		cursor: pointer;
		font-size: 14px;
		color: #374151;
		transition: background-color 0.2s;
	}

	.menu-item:hover {
		background-color: rgba(79, 70, 229, 0.08);
	}

	.menu-item.active {
		background-color: #d1fae5;
		color: #059669;
	}

	.menu-item i {
		font-size: 14px;
	}

	.sidebar-menu .el-menu-item {
		color: #374151;
		height: 48px;
		line-height: 48px;
		margin: 0 8px;
		border-radius: 8px;
		transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
		position: relative;
		overflow: hidden;
	}

	.sidebar-menu .el-menu-item::before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
		width: 3px;
		height: 0;
		background-color: #4f46e5;
		border-radius: 0 3px 3px 0;
		transition: height 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.sidebar-menu .el-menu-item:hover {
		background-color: rgba(79, 70, 229, 0.1);
		color: #1f2937;
	}

	.sidebar-menu .el-menu-item:hover::before {
		height: 24px;
	}

	.sidebar-menu .el-menu-item.is-active {
		background-color: rgba(79, 70, 229, 0.15);
		color: #1f2937;
	}

	.sidebar-menu .el-menu-item.is-active::before {
		height: 24px;
	}

	.main-content {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		background-color: #f5f7fa;
	}

	.content-header {
		padding: 16px 24px;
		background-color: #fff;
		border-bottom: 1px solid #e5e7eb;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	}

	.content-header h2 {
		font-size: 20px;
		font-weight: 600;
		color: #1f2937;
		margin: 0;
	}

	.content-body {
		flex: 1;
		padding: 9px;
		overflow-y: auto;
	}

	.fade-slide-enter-active {
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.fade-slide-leave-active {
		transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.fade-slide-enter {
		opacity: 0;
		transform: translateY(10px);
	}

	.fade-slide-leave-to {
		opacity: 0;
		transform: translateY(-10px);
	}

	.profile-filter {
		margin-bottom: 16px;
	}

	.data-type-select {
		width: 200px;
	}

	.profile-pagination {
		display: flex;
		justify-content: flex-end;
		margin-top: 16px;
	}
</style>